import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

/**
 * Texts of Bölge Müdürleri Raporları (`regionReports.*`). The parts shared
 * with SMO Lead Raporları (filters, worker table, report section) bring their
 * own `smoLead.*` texts. Excel exports stay Turkish.
 */
const useRegionText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`regionReports.${key}`, vars), [t]);
  return { t, language, locale, label };
};

export default useRegionText;
